import { RegistrationAffiliation } from "@/api/dtos";
import { useScopedField } from "@ngt/forms-core";

export const useIsCap = () => {
    const {state: {value: isCap}} = useScopedField<boolean>("isCap", {value: true});
    return isCap ?? false;
}

export const useIsSpeaker = () => {
    const {state: {value: isSpeaker}} = useScopedField<boolean>("isSpeaker", {value: true});
    return isSpeaker ?? false;
}

export const useIsBoard = () => {
    const {state: {value: isBoard}} = useScopedField<boolean>("isBoard", {value: true});
    return isBoard ?? false;
}

export const useIsTAndECSpeaker = () => {
    const {state: {value: isTAndECSpeaker}} = useScopedField<boolean>("isTAndECSpeaker", {value: true});
    return isTAndECSpeaker ?? false;
}

export const useRegistrationAffiliation = () => {
    const {state: {value: registrationAffiliation}} = useScopedField<RegistrationAffiliation>("registrationAffiliation", {value: true});
    return registrationAffiliation;
}

export const useIsSponsor = () => {
    const {state: {value: sponsor}} = useScopedField<boolean>("sponsor", {value: true});
    return sponsor ?? false;
}

export const useIsTrialCoordinator = () => {
    const {state: {value: trialCoordinator}} = useScopedField<boolean>("trialCoordinator", {value: true});
    return trialCoordinator ?? false;
}

export const useIsStaff = () => {
    const {state: {value: staff}} = useScopedField<boolean>("staff", {value: true});
    return staff ?? false;
}
